// extracted by mini-css-extract-plugin
export var colourBase = "FRNWEEpVtdsBHKhX9tUf";
export var colourDisabled = "Z7CkKUmavff8xdllkuzL";
export var colourInverted = "b2Nnz0h7zohWuZjjfKMS";
export var colourNegative = "mWM8TWiNkb6Lx0udnCvS";
export var colourPositive = "H50PDDyESGW2EAmQ4ce8";
export var colourSubdued = "O1W1Y0Rfxz7AldDahsot";
export var colourSubtle = "HfJ66n0wPDlIP1hiKn31";
export var colourUrgencyHigh = "iCQgmZjtMsQ5faws436L";
export var colourUrgencyMedium = "RagpInyL506jmnhXJtP3";
export var colourWarning = "GjvvIUIAloxwDWVEJNEw";
export var colourWhite = "DRZzO1glf8vg3brw_HQK";